// extracted by mini-css-extract-plugin
module.exports = {"nameFieldContainer":"Form__nameFieldContainer___s1HCE","nameField":"Form__nameField___2GLmU","largeRoundnessButton":"Form__largeRoundnessButton___3ZmkO"};